




















declare var window: any;
import { Component, Vue, Prop } from 'vue-property-decorator';
import ConfirmationModal from '@/components/Commons/ConfirmationModal.vue';
import { vxm } from '@/store.vuex';
@Component({})
export default class Header extends Vue {
  @Prop({ default: true }) showCloseButton;
  get name() {
    return vxm.users.myUserProfile.firstName;
  }
  onExitGuidedSignup() {
    vxm.users.Rudderstack.trackEvent("GSU Exited", {});
    this.$modal.show(
      ConfirmationModal,
      {
        header: this.$t('guidedsignup.exit.confirmation.header'),
        body: this.$t('guidedsignup.exit.confirmation.message'),
        okText: this.$t('global.ok.text'),
        cancelText: this.$t('global.cancel-text'),
        onOk: () => {
          let homeMenu: any = 'false';
          if (window.WorkLLama.isConfigJSONEnabled === 'true') {
            homeMenu = vxm.configs.ClientConfigs.slideMenuOptions.find(
              (menu) => menu.sectionKey === 'HOME' && menu.signInVisibility,
            );
          } else {
            homeMenu = vxm.utility.leftMenuOptions.find(
              (menu) => menu.alias === 'home' && menu.signInVisibility,
            );
          }
          this.$router.push({ path: homeMenu ? 'home' : 'findjobs' });
        },
      },
      {
        height: 'auto',
        clickToClose: false,
      },
    );
  }
}
